import EmailOrPhoneFieldWrapper from './EmailOrPhoneFieldWrapper.component';

export default EmailOrPhoneFieldWrapper;
